import { generateId } from '@freelancer/datastore/testing';
import { PartialBy } from '@freelancer/types';
import { TextEntityContextTypeApi } from 'api-typings/common/common';
import { SourceTypeApi } from 'api-typings/messages/messages_types';
import { TextEntity } from '../feed-posts/feed-posts.model';
import { Comment } from './comments.model';

export interface GenerateCommentOption {
  readonly fromUser: number;
  readonly comment: string;
  readonly parentId?: number;
  readonly threadId: number;
  readonly commentSource?: SourceTypeApi;
  readonly textEntities?: readonly PartialBy<
    PartialBy<TextEntity, 'id'>,
    'contextType'
  >[];
}

export function generateCommentObject({
  comment,
  fromUser,
  threadId,
  parentId,
  commentSource = SourceTypeApi.DEFAULT_MSG,
  textEntities = [],
}: GenerateCommentOption): Comment {
  const commentId = generateId();
  return {
    id: commentId,
    comment,
    fromUser,
    threadId,
    parentId,
    commentSource,
    textEntities: textEntities.map(textEntity => ({
      id: generateId(),
      contextId: commentId,
      contextType: TextEntityContextTypeApi.COMMENT,
      ...textEntity,
    })),
    timeCreated: Date.now(),
  };
}

export function generateCommentObjects(
  options: readonly GenerateCommentOption[],
): readonly Comment[] {
  return options.map(generateCommentObject);
}
